import React from 'react'
import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'
import { FaFolderOpen } from 'react-icons/fa'

const EfiPay = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    const handleUpload = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const allowed = [
            'application/x-pkcs12',
            'application/octet-stream'
        ];

        if (!allowed.includes(file.type)) {
            alert('Envie um certificado .p12 válido');
            event.target.value = '';
            return;
        }

        dispatch(change({ efipay_certificate_p12: file }))
    }

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.efipay_client_id) && true}
                    value={account.efipay_client_id || ''}
                    onChange={e => {
                        dispatch(change({efipay_client_id: e.target.value}))
                        if (error.efipay_client_id && delete error.efipay_client_id);
                    }}
                />

                {(error.efipay_client_id) &&
                    <strong className="text-danger">{error.efipay_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.efipay_client_secret) && true}
                    value={account.efipay_client_secret || ''}
                    onChange={e => {
                        dispatch(change({efipay_client_secret: e.target.value}))
                        if (error.efipay_client_secret && delete error.efipay_client_secret);
                    }}
                />

                {(error.efipay_client_secret) &&
                    <strong className="text-danger">{error.efipay_client_secret[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Certificado</label>
                
                <div>
                    <label htmlFor="certificate-upload" className="certificate-upload pointer">
                        <input className="sr-only" onChange={handleUpload} accept=".p12" required="" id="certificate-upload" name="file-upload" type="file" />
                        <div className="d-flex">
                            <FaFolderOpen className="text-muted" size={35} />

                            
                            <div className="d-flex flex-column ms-3">
                                {!account?.efipay_certificate_p12 ?
                                    <>
                                        <span className="fw-normal bs-color-b"><span className="text-success fw-medium">Clique aqui</span>  para procurar o arquivo </span>
                                        <p className="mt-1 small text-muted">.p12</p>
                                    </>
                                :
                                    <p className="mt-1 text-muted">{account.efipay_certificate_p12?.name}</p>
                                }
                            </div>
                        </div>
                    </label>
                </div>

                {(error.efipay_client_secret) &&
                    <strong className="text-danger">{error.efipay_client_secret[0]}</strong>
                }
            </div>
        </>
    )
}


export default EfiPay